module.exports = __webpack_public_path__ + "static/media/base-dark-text.bb9ba83e.png";